import React, { Fragment } from 'react';

const TableClientBalance = (usuarios) => {
    return (
        <Fragment>
            <table className="table table-condensed table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Usuario</th>
                        <th>Nombre</th>
                        <th>Correo</th>
                        <th>Saldo</th>
                    </tr>
                </thead>
                <tbody>
                    {usuarios.data ? usuarios.data.map((usuario, index) => (
                        <tr key={index}>
                            <td>{usuario.usuario}</td>
                            <td>{usuario.nombre} {usuario.apellidos}</td>
                            <td>{usuario.correo}</td>
                            <td>${usuario.saldo}</td>
                        </tr>
                    )) :
                        <tr>
                            <td colSpan="2">
                                <div className="alert alert-info">No hay usuarios con saldo para consultar</div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </Fragment>
    );
};

export default TableClientBalance;


// WEBPACK FOOTER //
// ./src/components/users/TableClientBalance.js